import React from 'react';
import {
  Edit as RaEdit,
  FormTab,
  required,
  TextInput,
  TabbedForm,
  useGetIdentity,
  CheckboxGroupInput,
  Toolbar,
  SaveButton,
  SelectInput,
  DeleteButton,
  ReferenceInput,
} from 'react-admin';
import { withPermissions } from '../../components/hoc/WithPermissions';

import {
  USER_ROLES,
  USER_ROLE,
  USER_TYPES,
} from '../../constants/statuses';
// import { filterToQueryBuilder } from '../../utils/helpers';

const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
    <DeleteButton style={{ marginLeft: 'auto' }} />
  </Toolbar>
);

const Edit = (props) => {
  const { loading: identityLoading } = useGetIdentity();

  if (identityLoading) {
    return null;
  }

  return (
    <RaEdit {...props}>
      <TabbedForm toolbar={<UserEditToolbar />}>
        <FormTab label="general">
          <TextInput source="fullName" validate={required()} />
          <TextInput source="email" validate={required()} />
          <TextInput source="password" />
          <ReferenceInput reference="geo-group" source="geoGroup.id" label="Geo group">
            <SelectInput />
          </ReferenceInput>
          <SelectInput source="type" choices={USER_TYPES} validate={required()} />
          <TextInput source="telegram" />
          <TextInput source="pstid" label="PST ID" />
        </FormTab>

        <FormTab label="roles">
          <CheckboxGroupInput source="roles" choices={USER_ROLES} row={false} />
        </FormTab>
      </TabbedForm>
    </RaEdit>
  );
};

export default withPermissions(
  Edit,
  null,
  [USER_ROLE.SUPER_ADMIN],
);
